module.exports = function(data) {
var __t, __p = '';
__p += '<div class="loading-spinner-wrapper">\n    <span class="loading-spinner">\n      <i class="one"></i><i class="two"></i><i class="three"></i>\n    </span>\n</div>\n';
return __p
}